import { getLocationTop10, ResGetLocationTop10 } from '@/service/tour/main/getLocationTop10';
import { useQuery } from '@tanstack/react-query';
import { RQMainKey } from './RQMainKey';

export const useLocationTop10Query = (location: string) => {
  return useQuery<ResGetLocationTop10, Error, ResGetLocationTop10['result']>({
    queryKey: RQMainKey.locationTop10(location),
    queryFn: () => getLocationTop10(location),
    select: (data) => data.result,
    staleTime: 1000 * 60 * 60 * 24,
    gcTime: 1000 * 60 * 60 * 24,
  });
};
